// extracted by mini-css-extract-plugin
module.exports = {"container":"PassengerVehicleCheckbox-module__container___3o5CE"};